import { Avatar } from "@mui/material";
import * as alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import { Storage } from 'aws-amplify';
import moment from 'moment';
import 'primeicons/primeicons.css';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import DeleteButton from '../../../../../components/common/buttons/DeleteButton';
import EditButton from '../../../../../components/common/buttons/EditButton';
import UserUploadFileButton from '../../../../../components/common/buttons/UploadButton';
import LeftSideBar from '../../../../../components/common/hr/leftnav.component';
import TopNav from '../../../../../components/common/hr/topnav.component';
import { ConvertResponseForSelect } from '../../../../../components/helper/commonfunctions';
import { DataTableCustomStyles } from '../../../../../components/helper/dataTable.config';
import { ValidateHRRole } from '../../../../../components/helper/validateRole';
import { TeamType } from "../../../../../models";
import HRLogin from '../../../../../setup/auth/hr.component';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import popupHeader from '../../../../../assets/images/popup_header_img.png';
import { graphQLGetAllData, graphQLFindRecordById } from '../../../../../components/helper/graphQLFunctions';
import { API, graphqlOperation } from 'aws-amplify';
import * as mutations from '../../../../../graphql/mutations';
import { PARAMETER_IDs } from "../../../../../components/helper/enum";
import AWS from 'aws-sdk';
var xlsx = require("xlsx")

export default function HrEmployees() {

    var myLambda = new AWS.Lambda();

    let navigateTo = useNavigate();
    const [isPageLoaded, setPageLoaded] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isDeleteUser, setDeleteUser] = useState(false);
    const [openSideBar, setOpenSideBar] = useState(false);
    const [isBulk, setIsBulk] = useState(false);
    const [progress, setProgress] = useState('');
    const [openCalculateActualsPopup, setOpenCalculateActualsPopup] = useState(false);
    const [financialYearList, setFinancialYearList] = useState([]);
    const [selectedFinancialYear, setFinancialYear] = useState("");
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
    const [employeePrimaryKey, setEmployeeePrimaryKey] = useState("");
    const [showLoader, setShowLoader] = useState(false);
    const [selectedFile, setSelectedFile] = useState([]);
    const [allSBUList, setAllSBUList] = useState([]);
    const [allBIUnit, setAllBIUnit] = useState([]);
    const [allRegions, setAllRegions] = useState([]);
    const [allCountries, setAllCountries] = useState([]);
    const [allBrands, setAllBrands] = useState([]);
    const [allGTM, setAllGTM] = useState([]);
    const [allSubGTM, setAllSubGTM] = useState([]);
    const [allProductGroup, setAllProductGroup] = useState([]);
    const [allCustomerCategory, setAllCustomerCategory] = useState([]);
    const [allCustomer, setAllCustomer] = useState([]);
    const [allProfitCenter, setAllProfitCenter] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [quarter, setQuarter] = useState({ label: "Q1", value: "1" });

    //*Employees Table Columns Name
    const parentDataTableColumns = [
        {
            name: 'Name',
            selector: row => row.name,
            cell: (row) => (
                <>
                    <div className="flex gap-4 items-center">
                        <Avatar
                            style={{ width: 28, height: 28 }}
                            alt={row.firstName + "" + row.lastName}
                            src={row.profilePic} />
                        {row.firstName + " " + row.lastName}
                    </div>
                </>
            ),
            width: "200px",
            sortable: true,
        },
        {
            name: "Role",
            selector: row => row.role,
            sortable: true,
        },
        {
            name: "Team Type",
            selector: row => row.teamType,
            sortable: true,
            cell: (row) => (
                row.teamType === TeamType.S ? 'Sales' :
                    row.teamType === TeamType.B ? 'Business' : 
                    row.teamType === "P" ? 'Pre-Sales':""
            ),
        },
        {
            name: "Employee ID",
            selector: row => row.employeeId,
            sortable: true,
            width: "200px",
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Reporting Manager',
            selector: row => row.parentEmployeeName,
            sortable: true,
            width: "200px",
        },
        {
            name: "Phone No",
            selector: row => row.phoneNo,
            sortable: true,
        },
        {
            name: "Joining Date",
            selector: row => row.joining_date,
            sortable: true,
            width: "200px",
        },
        {
            name: "Confirmation Date",
            selector: row => row.confirmation_date,
            sortable: true,
            width: "200px",
        }, {
            name: "Employee Class",
            selector: row => row.employee_class,
            sortable: true,
            width: "200px",
        }, {
            name: "Employee Type",
            selector: row => row.employee_type,
            sortable: true,
            width: "200px",
        }, {
            name: "Grade",
            selector: row => row.grade,
            sortable: true,
        }, {
            name: "Brand",
            selector: row => row.band,
            sortable: true,

        }, {
            name: "Last Working Day",
            selector: row => row.lwd,
            sortable: true,
            width: "200px",
        },
        {
            name: "Assign Target from HR ",
            selector: row => row.isAssignDirectTarget.toString(),
            width: "200px",
            cell: (row) => (
                <>
                    {
                        row.isAssignDirectTarget ?
                            <div className="flex gap-8">
                                <i className='pi pi-check-circle text-[#016939] text-lg' style={{ fontSize: 20 }}></i>
                            </div> : ""
                    }
                </>
            ),
            center: true
        },
        {
            name: 'Action',
            width: "200px",
            cell: (row) => (
                <>
                    <div className="flex gap-8 justify-center">
                        <Link onClick={() => handleCalculateActuals(row)}>
                            <i className="pi pi-calculator mt-1 opacity-80  my-auto relative right-[-14px]" style={{ fontSize: '1.2rem' }}></i></Link>
                        <Link className=" my-auto" onClick={() => handleOpenPopUp(row)}><UserUploadFileButton /></Link>
                        <Link className=" my-auto" onClick={(e) => handleEditClick(e, row['id'])} ><EditButton /></Link>
                        {/*
                            row.isDisable ?
                                <Link className="disabledCursor opacity-50 my-auto"><DeleteButton /></Link> :*/}
                                <Link className="my-auto" onClick={(e) => handleDeleteClick(e, [row['id']], "this record?")} ><DeleteButton /></Link>
                        {/**/}
                    </div>
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            center: true,
            button: true,
        }
    ];

    var quarterList = [
        { label: "Q1", value: "1" },
        { label: "Q2", value: "2" },
        { label: "Q3", value: "3" },
        { label: "Q4", value: "4" },
    ]



    const handleOpenPopUp = (row, isBulk=false) => {
        if(isBulk){
            setIsBulk(true)
        }
        else{
            setSelectedEmployeeId(row.id)
            setSelectedEmployee(row.name)
            setIsBulk(false)
        }
        setOpenSideBar(true)
    }

    const closeCalculatePopup = () => {
        setQuarter('');
        setFinancialYear('');
        setEmployeeePrimaryKey('');
        setSelectedEmployeeId('');
        setOpenCalculateActualsPopup(false);
    }

    const [isActualsCalculated, setActualsCalculated] = useState(false);

    const openAlert = async () => {
        const year = await graphQLFindRecordById('getFinancialYear', selectedFinancialYear);
        const yearFromToDate = moment(year.toDate).format('YYYY');

        if (!selectedFinancialYear) {
            toast.error('Please Select financial Year');
            return;
        }
        if (!quarter) {
            toast.error('Please Select quarter');
            return;
        }

        alertify.confirm('Confirmation', 'Do you want to calculate Actuals?', async function () {


            setActualsCalculated(true);
            const params = {
                FunctionName: 'fn_goalsheet_calculate_employee_actuals',
                Payload: JSON.stringify({
                    "employeeId": employeePrimaryKey,
                    "financialYearId": selectedFinancialYear,
                    "year": yearFromToDate,
                    "quarterNo": quarter
                }),
            };

            toast.info('Actuals are being calculated, please check after some time.');
            // const response = await myLambda.invoke(params).promise();
            // if (response) {
            //     toast.success('Actuals are calculated');
            // }

            myLambda.invoke(params, (err, data) => {
                if (err) {
                    console.error('Error invoking Lambda:', err);
                    toast.success('Actuals are calculated');
                    // Need to check the error
                    // toast.error('There was an error calculating the actuals. Please try again later.');
                } else {
                    toast.success('Actuals are calculated');
                    // If the Lambda function completes successfully, you can handle its response here if needed
                    // Optional: Show a success message if required later
                    // toast.success('Actuals calculation completed successfully.');
                }

                setActualsCalculated(false);
                setOpenCalculateActualsPopup(false);
            });
        }
            , function () {

                setQuarter('');
                setFinancialYear('');
                setEmployeeePrimaryKey('');
                setSelectedEmployeeId('');
                setOpenCalculateActualsPopup(false);
            });
    }

    //Validate admin Logged In
    const [isAuthenticated, userHasAuthenticated] = useState(true);

    //State
    const [employeeList, SetEmployeeList] = useState([]);
    const [employeeFilterList, SetEmployeeFilterList] = useState([]);

    async function onLoad() {
        try {
            if (!ValidateHRRole()) { userHasAuthenticated(false); }
        } catch (e) {
            userHasAuthenticated(false);
        }
    }

    //Edit Parent
    const handleEditClick = (e, id) => {
        e.preventDefault();
        navigateTo('/hr/settings/createemployee/' + id);
    };

    //Delete Employees
    const handleDeleteClick = async (e, id, message) => {
        e.preventDefault();

        alertify.confirm('Confirmation', `Do you want to delete ${message}`, async function () {

            setDeleteUser(true)

            //Delete Employees
            //const objDeleteEmployee = await DataStore.query(Employee, id);
            try{
            const objDeleteEmployees = await Promise.all(
                id.map(x=> graphQLFindRecordById('getEmployee', x))
            );

            //const objDeleteEmployee = await 
            // await DataStore.delete(objDeleteEmployee);
            await Promise.all(objDeleteEmployees.map(objDeleteEmployee => 
                API.graphql({
                    query: mutations.deleteEmployee,
                    variables: {
                        input: {
                            id: objDeleteEmployee.id,
                            _version: objDeleteEmployee._version,
                        }
                    }
                })
            ))

            // const objDeleteEmployeeParameters = await DataStore.query(EmployeeParameters, (c) => c.employee_id.eq(id));
            const objDeleteEmployeeParameters = await Promise.all(id.map(x=> 
                graphQLGetAllData('listEmployeeParameters', [{ employee_id: { eq: x } }])
            )); 
            
            // await DataStore.delete(objDeleteEmployeeParameters);
            await Promise.all(objDeleteEmployeeParameters.flat().map(o => 
                    API.graphql({
                        query: mutations.deleteEmployeeParameters,
                        variables: {
                            input: {
                                id: o.id,
                                _version: o._version,
                            }
                        }
                    })
            ))

            //const checkTarget = await DataStore.query(Targets, (c) => c.employee_id.eq(id));
            const checkTarget = await Promise.all(id.map(x=>
                graphQLGetAllData('listTargets', [{ employee_id: { eq: x } }])
            ));
  
            // const objDeleteEmployeeTargetDetails = await DataStore.query(TargetDetails, (c) => c.target_id.eq(x.id));
            
            const objDeleteEmployeeTargetDetails = await Promise.all(checkTarget.flat().map(x => 
                graphQLGetAllData('listTargetDetails', [{ target_id: { eq: x.id } }])
            ))
                /*for (var i = 0; i < checkTarget.length; i++) {
                    // Delete Target
                    //await DataStore.delete(Targets, x.id)

                    

                }*/
            //for (var p = 0; p < objDeleteEmployeeTargetDetails.length; p++) {
                        // Delete Target Details
                        // await DataStore.delete(TargetDetails, (c) => c.target_id.eq(x.id))
            //const toDeleteTargetDetails = await ;

            


                        // Delete Plan
                        // await DataStore.delete(Plan, (c) => c.target_detail_id.eq(objDeleteEmployeeTargetDetails[p].id))

            const toDeletePlans = await Promise.all(objDeleteEmployeeTargetDetails.flat().map(x=>
                graphQLGetAllData('listPlans', [{ target_detail_id: { eq: x.id } }])
            ))

            await Promise.all(objDeleteEmployeeTargetDetails.flat().map((o) => 
                API.graphql({
                    query: mutations.deleteTargetDetails,
                           variables: {
                            input: {
                                id: o.id,
                                _version: o._version,
                            }
                           }
                })
            ))

            await Promise.all(toDeletePlans.flat().map(o =>                 
                API.graphql({
                    query: mutations.deletePlan,
                        variables: {
                           input: {
                            id: o.id,
                            _version: o._version,
                        }
                    }
                })                 
            ))

                    

            await Promise.all(checkTarget.flat().map(x=>
                API.graphql({
                query: mutations.deleteTargets,
                    variables: {
                        input: {
                            id: x.id,
                            _version: x._version,
                        }
                    }
            })))
            setDeleteUser(false)
            toast.success("Deleted");
            BindList();
                    
            }
            catch(error){
                console.log(error);
            }
        }
            , function () { });
    };

    const handleCalculateActuals = (row) => {
        setEmployeeePrimaryKey(row.id)
        setSelectedEmployeeId(row.employeeId)
        setSelectedEmployee(row.name)
        setOpenCalculateActualsPopup(true);
    };


    //Get Employees List
    async function BindList() {
        setPageLoaded(false);
        // var financialYearRes = await DataStore.query(FinancialYear, Predicates.ALL, { sort: s => s.name(SortDirection.ASCENDING) });
        let financialYearRes = await graphQLGetAllData("listFinancialYears")
        financialYearRes = financialYearRes.sort((a, b) => a.name.localeCompare(b.name));
        var res = []; res = ConvertResponseForSelect(financialYearRes); setFinancialYearList(res)

        // var employeeResponse = await DataStore.query(Employee, Predicates.ALL, {
        //     sort: s => s.firstName(SortDirection.ASCENDING)
        // });

        let employeeResponse = await graphQLGetAllData("listEmployees")
        let roles = await graphQLGetAllData("listRoles")
        employeeResponse = employeeResponse.sort((a, b) => a.firstName.localeCompare(b.firstName));

        if (employeeResponse.length > 0) {
            var newResponse = [];
            try {
                employeeResponse.map(async (currentItem, i) => {
                    let profilePic = ""
                    if (currentItem.profilePic !== "") {
                        await Storage.get(currentItem.profilePic).then(result => { profilePic = result });
                    } else {
                        profilePic = "";
                    }

                    let isDisable = false;
                    // var checkForDelete = await DataStore.query(Employee, (c) => c.parentEmployeeId.eq(currentItem.id))
                    var checkForDelete = employeeResponse.find(o => o.parentEmployeeId === currentItem.id);

                    if (checkForDelete) {
                        isDisable = true
                    } else {
                        isDisable = false
                    }

                    //Role List
                    let role = "";
                    let teamType = "";
                    if (currentItem.role_id) {
                        // var roleResponse = await DataStore.query(Roles, currentItem.role_id)
                        var roleResponse = await graphQLFindRecordById("getRoles", currentItem.role_id);
                        
                        if (roleResponse) {
                            role = roleResponse.name
                            teamType = roleResponse.teamType
                        }
                    } else { role = ""; teamType = ""; }


                    //Parent Employee List
                    let empName = "-";
                    let parentEmployeeName = "";
                    let reverseParentEmployeeName = "";
                    if (currentItem.parentEmployeeId !== "") {
                        // var parentResponse = await DataStore.query(Employee, (c) => c.id.eq(currentItem.parentEmployeeId))
                        var parentResponse = employeeResponse.find(o => o.id === currentItem.parentEmployeeId);

                        if (parentResponse && parentResponse.firstName !== null) {
                            parentEmployeeName = parentResponse.firstName + " " + parentResponse.lastName
                            reverseParentEmployeeName = parentResponse.lastName + " " + parentResponse.firstName
                        } else {
                            parentEmployeeName = empName
                        }
                    }
                    newResponse.push({
                        "id": currentItem.id, "role_id": currentItem.role_id,
                        "name": currentItem.firstName + " " + currentItem.lastName,
                        "reverseName": currentItem.lastName + " " + currentItem.firstName,
                        "firstName": currentItem.firstName, "lastName": currentItem.lastName,
                        "email": currentItem.email, "parentEmployeeId": currentItem.parentEmployeeId, "address1": currentItem.address1, "address2": currentItem.address2, "phoneNo": currentItem.phoneNo,
                        "city": currentItem.city, "zip": currentItem.zip, "state": currentItem.state, "country": currentItem.country, "employeeId": currentItem.employeeId, "profilePic": profilePic, "isAssignDirectTarget": currentItem.isAssignDirectTarget, "param_sbu_id": currentItem.param_sbu_id,
                        "IsHRAccess": currentItem.IsHRAccess, "IsFinanceAccess": currentItem.IsFinanceAccess, "isDisable": isDisable, "role": role, "teamType": teamType,
                        "parentEmployeeName": parentEmployeeName, "reverseParentEmployeeName": reverseParentEmployeeName, "joining_date": currentItem.joining_date === "1970-05-07" ? "-" : currentItem.joining_date, "confirmation_date": currentItem.confirmation_date === "1970-05-07" ? "-" : currentItem.confirmation_date,
                        "employee_class": currentItem.employee_class, "employee_type": currentItem.employee_type, "grade": currentItem.grade, "band": currentItem.band, "lwd": currentItem.lwd === "1970-05-07" ? "-" : currentItem.lwd,
                    });

                    // //On Last Record assign to state
                    if (i === employeeResponse.length - 1) {
                        let sortArray = newResponse.sort((a, b) => (a.firstName > b.firstName ? 1 : -1))
                        SetEmployeeList(sortArray);
                        SetEmployeeFilterList(sortArray);
                        // setPageLoaded(true);
                    }
                })
            } catch (e) {
                setPageLoaded(true);
            }
        } else {
            SetEmployeeList([]);
            // setPageLoaded(true);
        }

        setPageLoaded(true);
    }

    const getMasterData = async () => {

        let sbuArray = await graphQLGetAllData("listSBUS")
        setAllSBUList(sbuArray)

        let parameterResponses = await graphQLGetAllData("listParameters")
        SetParametersList(parameterResponses)

        let BIUnitArray = await graphQLGetAllData("listBIUnits")
        setAllBIUnit(BIUnitArray)


        let regionsArray = await graphQLGetAllData("listRegions")
        setAllRegions(regionsArray)

        let brandArray = await graphQLGetAllData("listBrands")
        setAllBrands(brandArray)

        let GTMArray = await graphQLGetAllData("listGTMS")
        setAllGTM(GTMArray)

        let subGTMArray = await graphQLGetAllData("listSubGTMS")
        setAllSubGTM(subGTMArray)

        let countryArray = await graphQLGetAllData("listCountries")
        setAllCountries(countryArray)

        let productGroupArray = await graphQLGetAllData("listProductGroups")
        setAllProductGroup(productGroupArray)

        let customerCategoryArray = await graphQLGetAllData("listCustomerCategories")
        setAllCustomerCategory(customerCategoryArray)

        let customerArray = await graphQLGetAllData("listCustomers")
        setAllCustomer(customerArray);

        let profitCenterArray = await graphQLGetAllData("listProfitCenters")
        setAllProfitCenter(profitCenterArray)

        setIsDataLoaded(true);
    }


    useEffect(() => {
        // bindData()
        onLoad();
        BindList();
        getMasterData();
    }, []);

    //Search Employee
    const searchEmployees = (searchTerm) => {
        if (searchTerm.length > 1 && searchTerm != null) {
            let data = [...employeeFilterList]

            const filteredArr = data.filter((obj) => {
                return Object.values(obj).some((value) => {
                    return typeof value === "string" && value.trim().toLowerCase().replace(/\s+/g, "").includes(searchTerm.trim().toLowerCase().replace(/\s+/g, ""));
                });
            });

            SetEmployeeList(filteredArr)
        } else {
            let data = [...employeeFilterList]
            SetEmployeeList(data)
        }
    }


    const [parameterList, SetParametersList] = useState([]);

    //// ------------------------------------------------------------ MASTER DATA  **** START ***** --------------------------------------------------------------


    //*get SBUId________
    const getSBUId = (name) => {
        let _sbuList = [...allSBUList];
        var returnRecord = _sbuList.find(o => o.name.toLowerCase().trim() === name.toLowerCase().trim());
        if (returnRecord !== null && returnRecord !== undefined) { return returnRecord.id; } else { return ""; }
    }

    //*get BuId________
    const getBUId = (name) => {
        let _buList = [...allBIUnit];
        var returnRecord = _buList.find(o => o.name.toLowerCase().trim() === name.toLowerCase().trim());
        if (returnRecord !== null && returnRecord !== undefined) { return returnRecord.id; } else { return ""; }
    }

    //*get Bu REF_CODE________
    const getBuREF_CODE = (name) => {
        let _buList = [...allBIUnit];
        var returnRecord = _buList.find(o => o.name.toLowerCase().trim() === name.toLowerCase().trim());
        if (returnRecord !== null && returnRecord !== undefined) { return returnRecord.REF_CODE; } else { return ""; }
    }

    //*get RegionId________
    const getRegionId = (sbuId, regionId) => {
        let _regionList = [...allRegions];
        if (regionId) {
            var returnRecord = _regionList.find(o => (o.SBU_id.toLowerCase().trim() === sbuId.toLowerCase().trim() && o.name.toLowerCase().trim() === regionId.toLowerCase().trim()));
            if (returnRecord !== null && returnRecord !== undefined) { return returnRecord.id; } else { return ""; }
        }
    }

    //*get CountryId________
    const getCountryId = (regionId, name) => {
        let _countryList = [...allCountries];
        var returnRecord = _countryList.find(o => o.region_id?.toLowerCase().trim() === regionId?.toLowerCase().trim() && o.name?.toLowerCase().trim() === name.toLowerCase().trim());
        if (returnRecord !== null && returnRecord !== undefined) { return returnRecord.id; } else { return ""; }
    }

    //*get CountryId________
    const getBrandId = (sbuId, buId, brandName) => {
        let _brandList = [...allBrands];
        var returnRecord = _brandList.find(o => (o.SBU_id.toLowerCase().trim() === sbuId.toLowerCase().trim() && o.bu_id.toLowerCase().trim() === buId.toLowerCase().trim() && o.name.toLowerCase().trim() === brandName.toLowerCase().trim()));
        if (returnRecord !== null && returnRecord !== undefined) { return returnRecord.id; } else { return ""; }
    }

    //get Product Group________
    const getProductGroupId = (name) => {
        if (!name) return;
        let _productGroupList = [...allProductGroup];
        var returnRecord = _productGroupList.find(o => o.name.toLowerCase().trim() === name?.toLowerCase().trim());
        if (returnRecord !== null && returnRecord !== undefined) { return returnRecord.id; } else { return ""; }
    }

    //get Financial Year_______
    const getParameterId = (name) => {
        let _parameterList = [...parameterList];
        var returnRecord = _parameterList.find(o => o.name.toLowerCase().trim() === name?.toLowerCase().trim());
        // var returnRecord = _parameterList.find(o => o.name.toLowerCase().trim().includes(name.toLowerCase().trim()));
        if (returnRecord !== null && returnRecord !== undefined) { return returnRecord.id; } else { return ""; }
    }

    //get GtmId
    const getGtmId = (name) => {
        let _gtmList = [...allGTM];
        var returnRecord = _gtmList.find(o => o.name.toLowerCase().trim() === name.toLowerCase().trim());
        if (returnRecord !== null && returnRecord !== undefined) { return returnRecord.id; } else { return ""; }
    }

    //get GtmId
    const getSubGtmId = (name) => {
        let _subGtmList = [...allSubGTM];
        var returnRecord = _subGtmList.find(o => o.name.toLowerCase().trim() === name.toLowerCase().trim());
        if (returnRecord !== null && returnRecord !== undefined) { return returnRecord.id; } else { return ""; }
    }

    const getCustomerGroupId = (cgname, gtmId) => {
        let returnRecord = allCustomerCategory.find(c => c.name === cgname && c.gtm_i === gtmId);
        if (returnRecord !== null && returnRecord !== undefined) { return returnRecord.id; } else { return ""; }
    }

    const getCustomerId = (refCode) => {
        let returnRecord = allCustomer.find(c => c.REF_CODE === refCode);
        if (returnRecord !== null && returnRecord !== undefined) { return returnRecord.id; } else { return ""; }
    }

    //// ------------------------------------------------------------ MASTER DATA  **** END ***** --------------------------------------------------------------


    const changeAttachment = (e) => { setSelectedFile(e) }

    const importFile = () => {
        if (selectedFinancialYear === "") { toast.error("Select financial year"); return }
        if (selectedFile.length === 0) { toast.error("Select file to upload"); return }
        confirmDialog({
            message: 'Do you want to import this file?',
            header: 'Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: () => readUploadFile(selectedFile)
        });

    }

    
    const processFile = async (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
      
          reader.onload = async (e) => {
            try {
              const data = e.target.result;
              const workbook = xlsx.read(data, { type: "array" });
      
              const sheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[sheetName];
              let EmpName = worksheet['B3']?.v;
              let EmpId = worksheet['B4']?.v;
              let DOJ = worksheet['B5']?.v;
              let EmpDesign = worksheet['B6']?.v;
              let EmpReportingManager = worksheet['B11']?.v;
              let FinancialYearValue = worksheet['B14']?.v;
      
              let empData = {
                EmpName,
                EmpId,
                DOJ,
                EmpDesignation: EmpDesign,
                ReportingManager: EmpReportingManager,
                FinancialYearValue,
              };
      
              const sheetGoal = workbook.SheetNames[1];
              const worksheetGoal = workbook.Sheets[sheetGoal];
              const range = xlsx.utils.decode_range(worksheetGoal['!ref']);
              const endRow = range.e.r;
              const endColumn = range.e.c;
              const importRangeGoal = `A1:${xlsx.utils.encode_col(endColumn)}${endRow + 1}`;
      
              const goalSheetHeaders = [
                "SBU", "BU", "Cluster", "Country", "GTM", "SUBGTM", "Brand", "Product Group",
                "Customer Group", "Customer", "ProfitCenter"
              ];
              const employeeParameters = xlsx.utils.sheet_to_json(worksheetGoal, {
                range: importRangeGoal,
                header: goalSheetHeaders
              });
      
              const importRange = "A16:G30";
              const headers = ["parameter", "weightage", "q1_target", "q2_target", "q3_target", "q4_target", "year_target"];
              const json = xlsx.utils.sheet_to_json(worksheet, { range: importRange, header: headers });
      
              if (json) {
                for (let index = 0; index < json.length; index++) {
                  const obj = json[index];
                  obj["key"] = "Parameter " + (index + 1);
                  const parameterSheet = workbook.Sheets["Parameter " + (index + 1)];
      
                  if (parameterSheet) {
                    const paramRange = xlsx.utils.decode_range(parameterSheet['!ref']);
                    const paramEndRow = paramRange.e.r;
                    const paramEndColumn = paramRange.e.c;
      
                    const importParamRange = `A7:${xlsx.utils.encode_col(paramEndColumn)}${paramEndRow + 1}`;
                    const paramHeaders = [
                      "SBU", "BU", "Cluster", "Country", "GTM", "SubGTM", "Brand", "Product Group",
                      "Customer Group", "Customer", "Q1", "Q2", "Q3", "Q4", "AllTarget"
                    ];
                    const paramJson = xlsx.utils.sheet_to_json(parameterSheet, {
                      range: importParamRange,
                      header: paramHeaders
                    });
      
                    obj["parameterData"] = paramJson.length ? paramJson : [];
                  } else {
                    obj["parameterData"] = [];
                  }
                }
                // ⏳ Wait for saveData to finish
                await saveData(json, empData, employeeParameters);
              }
      
              resolve();
            } catch (err) {
              console.error("Error reading file:", file.name, err);
              reject(err);
            }
          };
      
          reader.onerror = (err) => reject(err);
          reader.readAsArrayBuffer(file);
        });
      };
      
    const readUploadFile = (e) => {
        e.preventDefault();
      
        const files = Array.from(e.target.files);
        if (!files || files.length === 0) return;
      
        const nonXlsxFiles = files.filter(file => !file.name.toLowerCase().endsWith('.xlsx'));

        if(nonXlsxFiles.length > 0){
            toast.error("Please select only .xlsx files");
            return;
        }
        setShowLoader(true);
        const processNext = (index) => {
            setProgress(`${index} completed out of ${files.length}`);
          if (index >= files.length) {
            setShowLoader(false);
            setOpenSideBar(false)
            setFinancialYear("");
            setSelectedEmployee("")
            setProgress("")
            toast.success("Success.");
            return;
          }
      
          processFile(files[index])
            .then(() => {
              processNext(index + 1); // proceed to next file
            })
            .catch((err) => {
              console.error("Error processing file:", files[index].name, err);
              processNext(index + 1); // continue even if error
            });
        };
      
        processNext(0); // start with first file
      };
      
      

    const saveData = async (empTargetData, empPersonalData, employeeParameters) => {

        let currentEmployeeDetails = employeeList.find(item => item.employeeId == empPersonalData.EmpId);
        let checkFinancialYear = await graphQLFindRecordById("getFinancialYear", selectedFinancialYear);
        await API.graphql(
            graphqlOperation(mutations.createEvaluation, {
                input:{
                    financial_year_id: selectedFinancialYear,
                    quaterNo: quarter.value,
                    startDate: checkFinancialYear.fromDate,
                    endDate: checkFinancialYear.toDate
                }
            }
        ))
        
        if (empPersonalData) {
            //Save employee Parameters
            if (employeeParameters.length) {

                let allData = await graphQLGetAllData("listEmployeeParameters", [{ employee_id: { eq: currentEmployeeDetails.id } }])

                for (let i = 0; i < allData.length; i++) {
                    await API.graphql({
                        query: mutations.deleteEmployeeParameters,
                        variables: {
                            input: {
                                id: allData[i].id,
                                _version: allData[i]._version
                            }
                        }
                    });
                }

                // OLD DataStore Code
                // await DataStore.delete(EmployeeParameters, (c) => c.employee_id.eq(selectedEmployeeId))

                let filterEmployeeParameters = employeeParameters.filter((e) => e.SBU && e.BU)

                if (filterEmployeeParameters.length) {
                    for (let i = 0; i < filterEmployeeParameters.length; i++) {
                        let currentSBU = filterEmployeeParameters[i].SBU ? allSBUList.find(o => o.name.toUpperCase() === filterEmployeeParameters[i].SBU.toUpperCase()) : '';

                        if (currentSBU) {
                            //BU REF CODE
                            // let bUResponse = await DataStore.query(BIUnit, (c) => c.name.eq(filterEmployeeParameters[i].BU));
                            let bUResponse = filterEmployeeParameters[i].BU ? allBIUnit.find(o => o.name.toUpperCase() === filterEmployeeParameters[i].BU.toUpperCase()) : '';
                            let bU_REF_CODE = bUResponse ? bUResponse.REF_CODE : "";
                            let buId = bUResponse ? bUResponse.id : "";

                            //Cluster/Region CODE
                            // let ClusterResponse = await DataStore.query(Region, (c) => c.name.eq(filterEmployeeParameters[i].Cluster.toUpperCase()));
                            let ClusterResponse = [];
                            if (filterEmployeeParameters[i].Cluster) {
                                ClusterResponse = filterEmployeeParameters[i].Cluster ? allRegions.find(o => o.name.toUpperCase() === filterEmployeeParameters[i].Cluster.toUpperCase()) : '';
                            }
                            let Cluster_REF_CODE = ClusterResponse ? ClusterResponse.REF_CODE : "";
                            let clusterId = ClusterResponse ? ClusterResponse.id : "";

                            //Country CODE
                            // let countryResponse = await DataStore.query(Country, (c) => c.name.eq(filterEmployeeParameters[i].Country.toUpperCase()));
                            let countryResponse = filterEmployeeParameters[i].Country ? allCountries.find(o => o.name.toUpperCase() === filterEmployeeParameters[i].Country.toUpperCase()) : '';
                            let country_REF_CODE = countryResponse ? countryResponse.REF_CODE : "";
                            let countryId = countryResponse ? countryResponse.id : "";

                            //Brand CODE
                            // let brandResponse = await DataStore.query(Brand, (c) => c.name.eq(filterEmployeeParameters[i].Brand));
                            let brandResponse = filterEmployeeParameters[i].Brand ? allBrands.find(o => o.name.toUpperCase() === filterEmployeeParameters[i].Brand.toUpperCase()) : '';
                            let brand_REF_CODE = brandResponse ? brandResponse.REF_CODE : "";


                            //GTM CODE
                            // let gtmResponse = await DataStore.query(GTM, (c) => c.name.eq(filterEmployeeParameters[i].GTM));
                            let gtmResponse = filterEmployeeParameters[i].GTM ? allGTM.find(o => o.name.toUpperCase() === filterEmployeeParameters[i].GTM.toUpperCase()) : '';
                            let GTM_REF_CODE = gtmResponse ? gtmResponse.REF_CODE : "";
                            let GTMId = gtmResponse ? gtmResponse.id : "";

                            //SubGtm CODE
                            // let subGtmResponse = await DataStore.query(SubGTM, (c) => c.name.eq(filterEmployeeParameters[i].SUBGTM));
                            let subGtmResponse = filterEmployeeParameters[i].SUBGTM ? allSubGTM.find(o => o.name.toUpperCase() === filterEmployeeParameters[i].SUBGTM.toUpperCase()) : '';
                            let SubGtm_REF_CODE = subGtmResponse ? subGtmResponse.REF_CODE : "";
                            let SubGtmId = subGtmResponse ? subGtmResponse.id : "";

                            //PG
                            // let pgResponse = await DataStore.query(ProductGroup, (c) => c.name.eq(filterEmployeeParameters[i]['Product Group']));
                            let pgResponse = filterEmployeeParameters[i]['Product Group'] ? allProductGroup.find(o => o.name.toUpperCase() === filterEmployeeParameters[i]['Product Group'].toUpperCase()) : '';
                            let PG_REF_CODE = pgResponse ? pgResponse.REF_CODE : "";

                            // //CusGroup
                            // let customerGroupResponse = await DataStore.query(CustomerCategory, (c) => c.name.eq(filterEmployeeParameters[i].CustomerGroup));
                            // let customerGroupResponse = allCustomerCategory.find(o => o.name === filterEmployeeParameters[i]['Customer Group'] ? filterEmployeeParameters[i]['Customer Group'] : filterEmployeeParameters[i]['Customer Group']);
                            let customerGroupResponse = filterEmployeeParameters[i]['Customer Group'] ? allCustomerCategory.find(o => o.name.toUpperCase() === filterEmployeeParameters[i]['Customer Group'].toUpperCase()) : '';

                            let CG_REF_CODE = customerGroupResponse ? customerGroupResponse.REF_CODE : "";
                            let CgId = customerGroupResponse ? customerGroupResponse.id : "";
                            //Customer
                            // let customerResponse = await DataStore.query(Customer, (c) => c.name.eq(filterEmployeeParameters[i].Customer));
                            // Found using name but we are getting customer code - Pratap
                            let customerResponse = allCustomer.find(o => o.REF_CODE == filterEmployeeParameters[i].Customer);
                            let Customer_REF_CODE = customerResponse ? customerResponse.REF_CODE : "";
                            let CustomerId = customerResponse ? customerResponse.id : "";

                            //ProfitCenter
                            // let profitCenterResponse = await DataStore.query(ProfitCenter, (c) => c.name.contains(filterEmployeeParameters[i].ProfitCenter));
                            let profitCenterResponse = allProfitCenter.find(o => o.name == filterEmployeeParameters[i].ProfitCenter);
                            let profitCenter_REF_CODE = profitCenterResponse ? profitCenterResponse.REF_CODE : "";
                            let profitCenterId = profitCenterResponse ? profitCenterResponse.id : "";

                            //Save Record Now.
                            // await DataStore.save(
                            //     new EmployeeParameters({
                            //         "employee_id": selectedEmployeeId,
                            //         "bu_id": buId,
                            //         "bu_REF_CODE": bU_REF_CODE,
                            //         "region_id": clusterId,
                            //         "region_REF_CODE": Cluster_REF_CODE,
                            //         "country_id": countryId,
                            //         "country_REF_CODE": country_REF_CODE,
                            //         "brand_REF_CODE": brand_REF_CODE,
                            //         "gtm_id": GTMId,
                            //         "gtm_REF_CODE": GTM_REF_CODE,
                            //         "sub_gtm_id": SubGtmId,
                            //         "sub_gtm_REF_CODE": SubGtm_REF_CODE,
                            //         "product_group_REF_CODE": PG_REF_CODE,
                            //         "customer_group_id": CgId,
                            //         "customer_segment_REF_CODE": CG_REF_CODE,
                            //         "customer_id": CustomerId,
                            //         "customer_REF_CODE": Customer_REF_CODE,
                            //         "profile_center_id": profitCenterId,
                            //         "profit_center_REF_CODE": profitCenter_REF_CODE
                            //     })
                            // );

                            await API.graphql(
                                graphqlOperation(mutations.createEmployeeParameters, {
                                    input: {
                                        employee_id: currentEmployeeDetails.id,
                                        bu_id: buId,
                                        bu_REF_CODE: bU_REF_CODE,
                                        region_id: clusterId,
                                        region_REF_CODE: Cluster_REF_CODE,
                                        country_id: countryId,
                                        country_REF_CODE: country_REF_CODE,
                                        brand_REF_CODE: brand_REF_CODE,
                                        gtm_id: GTMId,
                                        gtm_REF_CODE: GTM_REF_CODE,
                                        sub_gtm_id: SubGtmId,
                                        sub_gtm_REF_CODE: SubGtm_REF_CODE,
                                        product_group_REF_CODE: PG_REF_CODE,
                                        customer_group_id: CgId,
                                        customer_segment_REF_CODE: CG_REF_CODE,
                                        customer_id: CustomerId,
                                        customer_REF_CODE: Customer_REF_CODE,
                                        profile_center_id: profitCenterId,
                                        profit_center_REF_CODE: profitCenter_REF_CODE
                                    }
                                })
                            );

                        }
                    }
                }
            }

            //Check User
            // let checkFinancialYear = await DataStore.query(FinancialYear, (c) => c.id.eq(selectedFinancialYear))
            let checkFinancialYear = await graphQLFindRecordById("getFinancialYear", selectedFinancialYear);

            // let empDetails = await DataStore.query(Employee, (c) => c.id.eq(selectedEmployeeId))
            let empDetails = currentEmployeeDetails;

            if (empDetails && checkFinancialYear) {
                //Check weightage Relationship
                // var checkWeightageRelation = await DataStore.query(Relationship, (c) => c.and(c => [
                //     c.role_id.eq(empDetails.role_id),
                //     c.financial_year_id.eq(checkFinancialYear.id)
                // ]));

                let checkWeightageRelation = await graphQLGetAllData("listRelationships", [{ role_id: { eq: empDetails.role_id }, financial_year_id: { eq: checkFinancialYear.id } }])

                if (checkWeightageRelation.length === 0) {
                    // await DataStore.save(
                    //     new Relationship({
                    //         "financial_year_id": checkFinancialYear.id,
                    //         "role_id": empDetails.role_id,
                    //     })
                    // ).then(async (response) => { await saveWeightage(response.id, empTargetData) })

                    let createRelationship = await API.graphql(
                        graphqlOperation(mutations.createRelationship, {
                            input: {
                                financial_year_id: checkFinancialYear.id,
                                role_id: empDetails.role_id,
                            }
                        })
                    );
                    await saveWeightage(createRelationship.data.createRelationship.id, empTargetData)
                }

                // let checkTarget = await DataStore.query(Targets, (c) => c.and(c => [
                //     c.employee_id.eq(empDetails.id),
                //     c.report_manager_employee_id.eq(empDetails.id),
                //     c.financial_year_id.eq(checkFinancialYear.id)
                // ]));

                // Reporting manager id is removed for deleting all records of employee
                let checkTarget = await graphQLGetAllData("listTargets", [{ employee_id: { eq: empDetails.id }, financial_year_id: { eq: checkFinancialYear.id } }])

                if (checkTarget.length) {
                    for (var n = 0; n < checkTarget.length; n++) {
                        // Delete Target
                        // await DataStore.delete(Targets, x.id)

                        await API.graphql({
                            query: mutations.deleteTargets,
                            variables: {
                                input: {
                                    id: checkTarget[n].id,
                                    _version: checkTarget[n]._version
                                }
                            }
                        });

                        // const objDeleteEmployeeTargetDetails = await DataStore.query(TargetDetails, (c) => c.target_id.eq(x.id));

                        const objDeleteEmployeeTargetDetails = await graphQLGetAllData("listTargetDetails", [{ target_id: { eq: checkTarget[n].id } }])

                        for (var p = 0; p < objDeleteEmployeeTargetDetails.length; p++) {
                            // Delete Target Details
                            // await DataStore.delete(TargetDetails, (c) => c.target_id.eq(x.id))

                            await API.graphql({
                                query: mutations.deleteTargetDetails,
                                variables: {
                                    input: {
                                        id: objDeleteEmployeeTargetDetails[p].id,
                                        _version: objDeleteEmployeeTargetDetails[p]._version
                                    }
                                }
                            });

                            // Delete Plan
                            // await DataStore.delete(Plan, (c) => c.target_detail_id.eq(objDeleteEmployeeTargetDetails[p].id))
                            const objDeletePlan = await graphQLGetAllData("listPlans", [{ target_detail_id: { eq: objDeleteEmployeeTargetDetails[p].id } }])

                            for (var k = 0; k < objDeletePlan.length; k++) {
                                await API.graphql({
                                    query: mutations.deletePlan,
                                    variables: {
                                        input: {
                                            id: objDeletePlan[k].id,
                                            _version: objDeletePlan[k]._version
                                        }
                                    }
                                });
                            }
                        }
                    }
                }

                let targetDetails = await API.graphql(
                    graphqlOperation(mutations.createTargets, {
                        input: {
                            financial_year_id: checkFinancialYear.id,
                            employee_id: empDetails.id,
                            role_id: empDetails.role_id,
                            report_manager_employee_id: empDetails.parentEmployeeId,
                            isAddedByHRAdmin: false,
                            isAssignedToEmployee: true,
                            isSubmittedByEmployee: true
                        }
                    })
                );

                saveTargetDetails(targetDetails.data.createTargets.id, empTargetData)

            }
        }
    }

    const saveWeightage = async (relationId, empTargetData) => {
        // let checkRelationExist = await DataStore.query(RelationshipDetails, (c) => c.relationship_id.eq(relationId))
        let checkRelationExist = await graphQLGetAllData("listRelationshipDetails", [{ relationship_id: { eq: relationId } }])

        try {
            if (checkRelationExist.length === 0) {
                for (var i = 0; i < empTargetData.length; i++) {
                    if (empTargetData[i].parameterData.length > 0) {
                        let parameterId = getParameterId(empTargetData[i].parameter.trim())

                        // await DataStore.save(
                        //     new RelationshipDetails({
                        //         "relationship_id": relationId,
                        //         "parameter_id": parameterId,
                        //         "weightage": parseFloat(empTargetData[i].weightage) * 100
                        //     })
                        // ).then((response) => { })

                        await API.graphql(
                            graphqlOperation(mutations.createRelationshipDetails, {
                                input: {
                                    "relationship_id": relationId,
                                    "parameter_id": parameterId,
                                    "weightage": parseFloat(empTargetData[i].weightage) * 100
                                }
                            })
                        );
                    }

                }
            }

        } catch (e) { }
    }

    const saveCurrentTargetDetails = async (parameterData, targetId) => {
        let parameterId = getParameterId(parameterData.parameter.trim())
        if (parameterId) {
            const q1_target_value = parameterData.q1_target ? String(parameterData.q1_target) : "0";
            const q2_target_value = parameterData.q2_target ? String(parameterData.q2_target) : "0";
            const q3_target_value = parameterData.q3_target ? String(parameterData.q3_target) : "0";
            const q4_target_value = parameterData.q4_target ? String(parameterData.q4_target) : "0";
            let createdTargetDetails = await API.graphql(
                graphqlOperation(mutations.createTargetDetails, {
                    input: {
                        target_id: targetId,
                        parameter_id: parameterId,
                        target_value: parameterData.year_target ? String(parameterData.year_target) : 
                        Number(q1_target_value) + Number(q2_target_value) + Number(q3_target_value) + 
                        Number(q4_target_value),
                        q1_target_value,
                        q2_target_value,
                        q3_target_value,
                        q4_target_value,
                        target_assigned_date: moment().format(),
                        is_accepted_by_employee: true,
                        is_approve: true,
                        approved_date: moment().format(),
                        accepted_by_employee_date: moment().format(),
                        isMarkAsComplete: true,
                        isMarkAsComplete_AssignTarget: true,
                    }
                })
            );

            savePlan(createdTargetDetails.data.createTargetDetails.id, parameterData.parameterData)
        }
    }

    const saveNotIncludedTargetDetails = async (parameterId, targetId) => {
        let notFoundParameterDetails = parameterList.find(o => o.id === parameterId)
        let createdTargetDetails = await API.graphql(
            graphqlOperation(mutations.createTargetDetails, {
                input: {
                    target_id: targetId,
                    parameter_id: parameterId,
                    target_value: "0",
                    q1_target_value: "0",
                    q2_target_value: "0",
                    q3_target_value: "0",
                    q4_target_value: "0",
                    target_assigned_date: moment().format(),
                    is_accepted_by_employee: true,
                    is_approve: true,
                    approved_date: moment().format(),
                    accepted_by_employee_date: moment().format(),
                    isMarkAsComplete: true,
                    isMarkAsComplete_AssignTarget: true,
                }
            })
        );
        let myParamArray = [];
        myParamArray.push(notFoundParameterDetails)

        savePlan(createdTargetDetails.data.createTargetDetails.id, myParamArray)
    }

    const saveTargetDetails = async (targetId, getEmpTargetData) => {
        
        let empTargetData = getEmpTargetData.filter((a) => a.parameterData)


        let NWCParameterDetails = empTargetData.find(o => o.parameter === "NWC Days")
        let NWCV2ParameterDetails = empTargetData.find(o => o.parameter === "NWC Days V2")
        let DIOParameterDetails = empTargetData.find(o => o.parameter === "DIO")
        let DSOParameterDetails = empTargetData.find(o => o.parameter === "DSO")
        let DVROParameterDetails = empTargetData.find(o => o.parameter === "DVRO")
        let DPOParameterDetails = empTargetData.find(o => o.parameter === "DPO")
        let GMPParameterDetails = empTargetData.find(o => o.parameter === "GM %")
        let GMDParameterDetails = empTargetData.find(o => o.parameter === "GM $")
        let RevenueParameterDetails = empTargetData.find(o => o.parameter === "Revenue")

        if (GMPParameterDetails || GMDParameterDetails) {
            GMDParameterDetails ? saveCurrentTargetDetails(GMDParameterDetails, targetId) : saveNotIncludedTargetDetails(PARAMETER_IDs['Gross Margin $'], targetId);
            GMPParameterDetails ? saveCurrentTargetDetails(GMPParameterDetails, targetId) : saveNotIncludedTargetDetails(PARAMETER_IDs['Gross Margin %'], targetId);
        }

        if (RevenueParameterDetails) {
            saveCurrentTargetDetails(RevenueParameterDetails, targetId)
        }

        if (NWCV2ParameterDetails) {
            saveCurrentTargetDetails(NWCV2ParameterDetails, targetId)
        }

        if (NWCParameterDetails) {
            saveCurrentTargetDetails(NWCParameterDetails, targetId)
            DIOParameterDetails ? saveCurrentTargetDetails(DIOParameterDetails, targetId) : saveNotIncludedTargetDetails(PARAMETER_IDs.DIO, targetId);
            DSOParameterDetails ? saveCurrentTargetDetails(DSOParameterDetails, targetId) : saveNotIncludedTargetDetails(PARAMETER_IDs.DSO, targetId);
            DVROParameterDetails ? saveCurrentTargetDetails(DVROParameterDetails, targetId) : saveNotIncludedTargetDetails(PARAMETER_IDs.DVRO, targetId);
            DPOParameterDetails ? saveCurrentTargetDetails(DPOParameterDetails, targetId) : saveNotIncludedTargetDetails(PARAMETER_IDs.DPO, targetId);
        }
        else {
            if (DIOParameterDetails)
                saveCurrentTargetDetails(DIOParameterDetails, targetId)

            if (DSOParameterDetails)
                saveCurrentTargetDetails(DSOParameterDetails, targetId)

            if (DVROParameterDetails)
                saveCurrentTargetDetails(DVROParameterDetails, targetId)

            if (DPOParameterDetails)
                saveCurrentTargetDetails(DPOParameterDetails, targetId)
        }

        // Remove previously added parameters from array
        empTargetData = empTargetData.filter((e) =>
            e.parameter !== "GM %"
            && e.parameter !== "GM $"
            && e.parameter !== "Revenue"
            && e.parameter !== "NWC Days"
            && e.parameter !== "DIO"
            && e.parameter !== "DSO"
            && e.parameter !== "DVRO"
            && e.parameter !== "DPO"
            && e.parameter !== "NWC Days V2"
        )


        for (let k = 0; k < empTargetData.length; k++) {
            saveCurrentTargetDetails(empTargetData[k], targetId)
        }

        // Commented because we have used it  in common
        // setShowLoader(false);
        // setOpenSideBar(false)
        // setFinancialYear("");
        // setSelectedEmployee("")
        // toast.success("Success.");

        // try {
        //     for (var i = 0; i < empTargetData.length; i++) {
        //         if (i === empTargetData.length - 1) {
        //             setShowLoader(false);
        //             setOpenSideBar(false)
        //             setFinancialYear("");
        //             setSelectedEmployee("")
        //             toast.success("Success.");
        //         }

        //         if (empTargetData[i].parameterData.length > 0) {
        //             let parameterId = getParameterId(empTargetData[i].parameter.trim())

        //             // await DataStore.save(
        //             //     new TargetDetails({
        //             //         "target_id": targetId,
        //             //         "parameter_id": parameterId,
        //             //         "target_value": empTargetData[i].year_target ? String(empTargetData[i].year_target) : "0",
        //             //         "q1_target_value": empTargetData[i].q1_target ? String(empTargetData[i].q1_target) : "0",
        //             //         "q2_target_value": empTargetData[i].q2_target ? String(empTargetData[i].q2_target) : "0",
        //             //         "q3_target_value": empTargetData[i].q3_target ? String(empTargetData[i].q3_target) : "0",
        //             //         "q4_target_value": empTargetData[i].q4_target ? String(empTargetData[i].q4_target) : "0",
        //             //         "target_assigned_date": moment().format(),
        //             //         "is_accepted_by_employee": true,
        //             //         "is_approve": true,
        //             //         "approved_date": moment().format(),
        //             //         "accepted_by_employee_date": moment().format(),
        //             //         "isMarkAsComplete": true,
        //             //         "isMarkAsComplete_AssignTarget": true,
        //             //     })
        //             // ).then((result) => {
        //             //     savePlan(result.id, empTargetData[i].parameterData)
        //             // })



        //             let createdTargetDetails = await API.graphql(
        //                 graphqlOperation(mutations.createTargetDetails, {
        //                     input: {
        //                         target_id: targetId,
        //                         parameter_id: parameterId,
        //                         target_value: empTargetData[i].year_target ? String(empTargetData[i].year_target) : "0",
        //                         q1_target_value: empTargetData[i].q1_target ? String(empTargetData[i].q1_target) : "0",
        //                         q2_target_value: empTargetData[i].q2_target ? String(empTargetData[i].q2_target) : "0",
        //                         q3_target_value: empTargetData[i].q3_target ? String(empTargetData[i].q3_target) : "0",
        //                         q4_target_value: empTargetData[i].q4_target ? String(empTargetData[i].q4_target) : "0",
        //                         target_assigned_date: moment().format(),
        //                         is_accepted_by_employee: true,
        //                         is_approve: true,
        //                         approved_date: moment().format(),
        //                         accepted_by_employee_date: moment().format(),
        //                         isMarkAsComplete: true,
        //                         isMarkAsComplete_AssignTarget: true,
        //                     }
        //                 })
        //             );
        //             savePlan(createdTargetDetails.data.createTargetDetails.id, empTargetData[i].parameterData)
        //         }
        //     }
        // } catch (e) { }
    }

    var savePlan = async (targetDetailId, findData) => {
        for (var i = 0; i < findData.length; i++) {

            let sbuId; if (findData[i].SBU) { sbuId = getSBUId(findData[i].SBU) } else { sbuId = "" }
            if (sbuId) {
                let buId; let buREF_CODE;
                if (findData[i].BU) {
                    buId = getBUId(findData[i].BU)
                    buREF_CODE = getBuREF_CODE(findData[i].BU)
                } else { buId = ""; buREF_CODE = ""; }

                let regionId;
                if (findData[i].Cluster) { regionId = getRegionId(sbuId, findData[i].Cluster) } else { regionId = "" }

                let countryId;
                if (regionId) { countryId = getCountryId(regionId, findData[i].Country) } else { countryId = "" }

                let brandId;
                if (findData[i].Brand) { brandId = getBrandId(sbuId, buId, findData[i].Brand) } else { brandId = "" }

                let productGroupId;
                if (findData[i]["Product Group"]) { productGroupId = getProductGroupId(findData[i]["Product Group"]) } else { productGroupId = "" }
                let gtmId;
                if (findData[i].GTM) { gtmId = getGtmId(findData[i].GTM) } else { gtmId = "" }

                let subGtmId;
                if (findData[i].SubGTM) { subGtmId = getSubGtmId(findData[i].SubGTM) } else { subGtmId = "" }

                let customerGroupId;
                if (findData[i]["Customer Group"]) { customerGroupId = getCustomerGroupId(findData[i]["Customer Group"], gtmId) }

                let customerId;
                if (findData[i]["Customer"]) { customerId = getCustomerId(findData[i]["Customer"]) }

                // await DataStore.save(
                //     new Plan({
                //         "target_detail_id": targetDetailId,
                //         "bu_REF_CODE": buREF_CODE,
                //         "sbu_id": sbuId,
                //         "bu_id": buId,
                //         "region_id": regionId,
                //         "country_id": countryId,
                //         "brand_id": brandId,
                //         "product_group_id": productGroupId,
                //         "customer_group_id": "0",
                //         "customer_id": "0",
                //         "gtm_Id": gtmId,
                //         "sub_gtm_id": subGtmId,
                //         "target_value": findData[i].annualTarget ? String(findData[i].annualTarget) : "0",
                //         "q1_target_value": findData[i].Q1 ? String(findData[i].Q1) : "0",
                //         "q2_target_value": findData[i].Q2 ? String(findData[i].Q2) : "0",
                //         "q3_target_value": findData[i].Q3 ? String(findData[i].Q3) : "0",
                //         "q4_target_value": findData[i].Q4 ? String(findData[i].Q4) : "0",
                //     })
                // )

                await API.graphql(
                    graphqlOperation(mutations.createPlan, {
                        input: {
                            target_detail_id: targetDetailId,
                            bu_REF_CODE: buREF_CODE,
                            sbu_id: sbuId,
                            bu_id: buId,
                            region_id: regionId,
                            country_id: countryId,
                            brand_id: brandId,
                            product_group_id: productGroupId,
                            customer_group_id: customerGroupId,
                            customer_id: customerId,
                            gtm_Id: gtmId,
                            sub_gtm_id: subGtmId,
                            target_value: findData[i].annualTarget ? String(findData[i].annualTarget) : "0",
                            q1_target_value: findData[i].Q1 ? String(findData[i].Q1) : "0",
                            q2_target_value: findData[i].Q2 ? String(findData[i].Q2) : "0",
                            q3_target_value: findData[i].Q3 ? String(findData[i].Q3) : "0",
                            q4_target_value: findData[i].Q4 ? String(findData[i].Q4) : "0",
                        }
                    })
                );

            }
        }
    }

    const handleSelectedRowsChange = (selectedRows) => {
        setSelectedEmployees(selectedRows.selectedRows);
    };

    const handelSendEmail = async () => {

        for (let i = 0; i < selectedEmployees.length; i++) {
            const params = {
                FunctionName: 'RedingtonEvalMailFunction',
                Payload: JSON.stringify({
                    "to": selectedEmployees[i].email
                }),
            };

            const response = await myLambda.invoke(params).promise();
            if (response.StatusCode === 200) {
                toast.success('Email Sent!');
            }

        }

        setSelectedEmployees([]);
    }

    // ------------------------------------------------------------------------------------------------------


    return isAuthenticated ? (
        <div>
            <div className="pt-16">
                <TopNav />
                <LeftSideBar />
                <div className="dashboard-main-wrapper pl-20 pr-4 mt-3">
                    <div className="flex flex-1 flex-wrap p-5 pb-4 px-0 top-action-wrapper">
                        <div className="md:flex xs:w-full sm:w-full md:w-auto flex-row align-center">
                            <div className="md:flex block md:col-span-2 mb-4">
                            </div>
                            <div className="md:flex block mb-4">
                                <h2 className="page-title">Employees</h2>
                            </div>
                        </div>

                        <div className="md:flex flex-1 flex-row xs:w-full sm:w-full md:w-auto align-center justify-end md:ml-auto gap-3 right-side">
                            <div className="relative">
                                <input onChange={(e) => searchEmployees(e.target.value)} type="text" id="required-search" className="rounded-md border border-[#D0D5DD] focus:border-transparent w-full py-2.5 pl-3 bg-white text-gray-700 placeholder-gray-500 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 dark:bg-[#403E3C] dark:text-[#FFFFFF] dark:border-[#403E3C]" placeholder="Search..." />
                            </div>
                            <div className="md:flex block  gap-4 mb-4">
                                <Link to="/hr/settings" className=" py-2 px-5 bg-white text-[#344054] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:bg-[#4A5056]  dark:border-[#333231] dark:text-[#FFFFFF]">Back</Link>
                                <Link to="/hr/settings/createemployee" className=" py-2 px-6 bg-btn-blue text-[#fff] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md">Create</Link>
                                <Link to="/hr/settings/organizationchart" className=" py-2 px-6 bg-btn-blue text-[#fff] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md">Organization Chart</Link>
                                <Link onClick={() => handleOpenPopUp([], true)} className=" py-2 px-6 bg-btn-blue text-[#fff] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md">Bulk Target Upload</Link>
                                {selectedEmployees.length > 0 && <Link to="#" className=" py-2 px-6 bg-btn-blue text-[#fff] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] "
                                    onClick={() => {
                                        handelSendEmail();
                                    }}
                                >Send E-mail</Link>}
                                {selectedEmployees.length > 0 && <Link onClick={(e) => {handleDeleteClick(e, selectedEmployees.map(x=>x.id), "all records?")}} className=" py-2 px-6 bg-btn-blue text-[#fff] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md">Delete</Link>}
                            </div>

                        </div>
                    </div>
                    <div>
                        <div className={"block w-full pt-5"}>
                            {
                                isPageLoaded &&
                                <DataTable
                                    columns={parentDataTableColumns}
                                    data={employeeList}
                                    customStyles={DataTableCustomStyles}
                                    pagination
                                    highlightOnHover
                                    paginationPerPage={10}
                                    selectableRows // Enable row selection
                                    selectableRowsHighlight // Highlight the selected rows
                                    onSelectedRowsChange={handleSelectedRowsChange}
                                />
                            }

                            {
                                !isPageLoaded &&
                                <div className='text-center py-8' ><ProgressSpinner /></div>
                            }


                            {
                                <Dialog visible={isDeleteUser} style={{ width: '40vw' }} showHeader={false}>
                                    <div className='text-center py-8' ><ProgressSpinner /></div>
                                    <h2 className="page-title text-center">Please wait while deleting employee.</h2>
                                </Dialog>
                            }
                        </div>
                    </div>
                </div>

                <>
                    {
                        openSideBar &&
                        <div style={{ width: "34.271vw", animation: "popupDiv-slide-in 0.5s forwards" }} id="editPopupCont" className="sidenav">

                            <div className="popup_header relative">
                                <img src={popupHeader} alt="" />
                                <div className="absolute right-0 left-0 top-0 w-full text-white">
                                    <div className="flex justify-between px-6 py-2 bg-black/[0.5]">
                                        <div className="text-md">
                                            {
                                                isBulk == true ? "Bulk upload" : "Employee Details"
                                            }
                                        </div>
                                        <div><Link onClick={() => setOpenSideBar(false)} className="closebtn text-2xl leading-none removeClass">&times;</Link></div>
                                    </div>
                                    <div className="flex justify-between px-6 m mt-6 lg:mt-8 2xl:mt-5 xl:mt-3">
                                        <div className="text-sm">
                                            {isBulk == true ? `${progress}` : `Employee Name: ${selectedEmployee}`}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="p-6 height-custtom">

                                <Dropdown disabled={showLoader ? true : false} value={selectedFinancialYear} onChange={(e) => setFinancialYear(e.value)} options={financialYearList}
                                    optionLabel="label"
                                    placeholder="Select Financial Year" className="w-full md:w-14rem" />

                                <div className='mt-10'>
                                    {
                                        selectedFinancialYear &&
                                        <>
                                            <span>Browse File <label className="text-[#FF0000] text-[14px] font-medium">
                                            * </label></span>
                                            <div>
                                                <button className="border text-[Black] flex bg-[white] rounded-md p-2  border-[#D0D5DD] pr-3 cursor-pointer">
                                                    <input
                                                        // onChange={(e)=> readUploadFile}
                                                        onChange={(e) => { changeAttachment(e) }}
                                                        accept=".xlsx" id="fileImport"
                                                        multiple="multiple" type="file" className="cursor-pointer" />
                                                </button>
                                            </div>
                                            <span className='text-muted font-size-muted'>Note: Please select .xlsx file</span>
                                        </>
                                    }
                                </div>

                                {
                                    showLoader &&
                                    <div style={{ textAlign: "center" }}>
                                        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                                    </div>
                                }

                            </div>
                            <div className="lg:absolute left-0 right-0 bottom-0 bg-[#E5F3EC] dark:bg-[#071008] p-5">
                                {
                                    <div className="flex justify-end gap-2">
                                        <div><Link onClick={() => setOpenSideBar(false)} className="bg-white border border-[#C6CBD2] rounded-md text-sm px-4 py-2 removeClass dark:bg-[#4A5056] dark:border-[#4A5056] dark:text-white" >Cancel</Link></div>
                                        {
                                            isDataLoaded &&
                                            <div><Link onClick={importFile} className="bg-[#029046] border border-[#029046] rounded-md text-sm text-white px-4 py-2">Import</Link></div>
                                        }
                                        {
                                            !isDataLoaded &&
                                            <div><Link title="Please wait while data loading..." className="bg-[#029046] border border-[#029046] rounded-md text-sm text-white px-4 py-2 opacity-50 cursor-not-allowed">Import</Link></div>
                                        }
                                        
                                    </div>
                                }
                            </div>


                        </div>
                    }
                </>
                <ConfirmDialog />
                <>
                    {
                        openCalculateActualsPopup &&
                        <div style={{ width: "34.271vw", animation: "popupDiv-slide-in 0.5s forwards" }} id="editPopupCont" className="sidenav">

                            <div className="popup_header relative">
                                <img src={popupHeader} alt="" />
                                <div className="absolute right-0 left-0 top-0 w-full text-white">
                                    <div className="flex justify-between px-6 py-2 bg-black/[0.5]">
                                        <div className="text-md">Calculate Actuals</div>
                                        <div onClick={() => closeCalculatePopup()} ><Link className="closebtn text-2xl leading-none removeClass">&times;</Link></div>
                                    </div>
                                    <div className="flex justify-between px-6 m mt-6 lg:mt-8 2xl:mt-5 xl:mt-3">
                                        <div>
                                            <div className="text-sm">Employee ID: {selectedEmployeeId}</div>
                                        </div>
                                        <div>
                                            <div className="text-sm">Employee Name: {selectedEmployee}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {isActualsCalculated === false ?
                                <div className="p-6 height-custtom">
                                    <div>
                                        <div className="text-sm">Employee Name: <b>{selectedEmployee}</b></div>
                                    </div>
                                    <div>
                                        <label className="text-sm flex items-center dark:text-white mt-4">Financial Year <label className="text-[#FF0000] text-[14px] font-medium">
                                            * </label>
                                        </label>
                                    </div>

                                    <Dropdown disabled={showLoader ? true : false} value={selectedFinancialYear} onChange={(e) => setFinancialYear(e.value)} options={financialYearList}
                                        optionLabel="label"
                                        placeholder="Select Financial Year" className=" mt-4 w-full md:w-14rem" />

                                    <div>
                                        <label className="text-sm flex items-center  dark:text-white mt-4">Quarter <label className="text-[#FF0000] text-[14px] font-medium">
                                            * </label>
                                        </label>
                                    </div>

                                    <Dropdown disabled={showLoader ? true : false} value={quarter} onChange={(e) => setQuarter(e.value)} options={quarterList}
                                        optionLabel="label"
                                        placeholder="Select Quarter" className=" mt-4 w-full md:w-14rem" />

                                    {
                                        showLoader &&
                                        <div style={{ textAlign: "center" }}>
                                            <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                                        </div>
                                    }

                                </div>
                                :
                                <div className='text-center py-8' ><ProgressSpinner /></div>

                            }


                            <div className="lg:absolute left-0 right-0 bottom-0 bg-[#E5F3EC] dark:bg-[#071008] p-5">
                                {
                                    <div className="flex justify-end gap-2">
                                        <div onClick={() => closeCalculatePopup()} ><Link className="bg-white border border-[#C6CBD2] rounded-md text-sm px-4 py-2 removeClass dark:bg-[#4A5056] dark:border-[#4A5056] dark:text-white" >Cancel</Link></div>
                                        <div><Link onClick={() => openAlert()} className="bg-[#029046] border border-[#029046] rounded-md text-sm text-white px-4 py-2">{isActualsCalculated === true ? 'Please Wait' : 'Calculate Actuals'}</Link></div>
                                    </div>
                                }
                            </div>


                        </div>
                    }
                </>
            </div>
        </div>
    ) : (
        <HRLogin sessionExpired={1} />
    )
}
